@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.header {
  font-size: 13px;
  margin-bottom: 5px;
  color: @orders-drawer--default--text-color;
}

.orders-header {
  padding: 5px 5px 5px 10px;
  background-color: @orders-drawer--default--header--background-color;
  border: 1px solid @orders-drawer--default--border-color;
  display: flex;
  justify-content: space-between;
}

.actions {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.header-actions {
  display: flex;
  align-items: center;
}
